import type { ISkuItem } from '../mappers/product-to-sku-list';
import type { IPhoto, ISkuPhotoItemCharacteristic } from '../models/slider';

export function getCurrentSkuPhoto(currentSku: ISkuItem | null, photos: IPhoto[]): IPhoto | undefined {
  if (!currentSku) return photos?.[0];
  
  const photoCharacteristic: ISkuPhotoItemCharacteristic = currentSku.characteristics.find(
    (characteristic: any) => characteristic.type === 'image',
  ) as ISkuPhotoItemCharacteristic;

  if (!photoCharacteristic) return photos.slice().shift();
  return photos.find((photo) => photo.photoKey === photoCharacteristic.value.photoKey);
}
